import {useCallback, useState} from 'react'

/**
 * Per-row heights for a scheduler view whose rows are normally all
 * `baseHeight`. A row grows only when its label asked for more
 * (`ResourceLabel`'s `onNeededHeight`) and shrinks back when it no longer does.
 */
export const useRowHeights = (baseHeight: number) => {
  const [needed, setNeeded] = useState<Record<string, number>>({})

  const heightOf = useCallback(
    (rowId: unknown) => Math.max(baseHeight, needed[String(rowId)] || 0),
    [baseHeight, needed]
  )

  const reporterFor = useCallback(
    (rowId: unknown) => (px: number) =>
      setNeeded((prev) => {
        const key = String(rowId)
        if (Math.abs((prev[key] || 0) - px) < 1) return prev
        return {...prev, [key]: px}
      }),
    []
  )

  return {heightOf, reporterFor}
}
